import Vue from "vue"

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('formatDatetime', function (value) {
  if (!value) return ''
	return value
		.substring(0, 10)
		.split("-")
		.reverse()
		.join("/");
});

Vue.filter('formatCurrency', function(val) {
	return `R$ ${(Number(val)/100).toFixed(2)}`;
});

Vue.filter('formatMoney', function(val) {
	return val ? parseFloat(val)?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "";
});

Vue.filter('formatDurationHours', function(val) {
	return val.slice(0,5);
});

Vue.filter('formatOrderStatus', function(val) {
	switch(val){
		case "OPEN": return "Aberto";
		case "AWAITING_PAYMENT": return "Pagamento pendente";
		case "DELIVERY_PENDING": return "Entrega pendente";
		case "IN_DELIVERY": return "Em entrega";
		case "FULFILLED": return "Concluído";
		default: return "";
	}
});

Vue.filter('limitText', function(text, maxLength = 100) {
	if (text.length > maxLength) {
		return text.substr(0, maxLength) + "...";
	}
	return text;
});
